import { ENDPOINTS } from "../../apiConfig";
import axiosRequest from "../universal/axiosService";

export const getRAMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "RA",
            type: "RA_METRICS",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getRAJobPostingMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "RA",
            type: "RA_JOBPOSTING_METRICS",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getRAMetricsOverview = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "RA",
            type: "RA_METRICS_OVERVIEW",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getRAMetricsGroup = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "RA",
            type: "RA_METRICS_GROUP",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getBDMMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
        params: {
            coll: "JobPosting",
            useAggregate: true,
            ...({ queryMode: params.queryMode } || {}),
            fil: JSON.stringify(params.fil) || null
        }
    });
};
export const getBDMJobsMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
        params: {
            coll: "JobPosting",
            useAggregate: true,
            queryMode: "BDM_METRICS_GROUP",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getRecruiterMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.SUBMISSOINS.GET_ALL,
        params: {
            coll: "Submission",
            useAggregate: true,
            fil: JSON.stringify(params.fil) || null,
            ...({ queryMode: params.queryMode } || {}),
        }
    });
};

export const getRecruiterMetricsGroup = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.SUBMISSOINS.GET_ALL,
        params: {
            coll: "Submission",
            useAggregate: true,
            fil: JSON.stringify(params.fil) || null,
            ...({ queryMode: params.queryMode } || {}),
        }
    });
};

export const getDashboardHierarchy = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: ENDPOINTS.USER_REFS.ATS_USER_HIERARCHY,
        params: {
            fil: JSON.stringify(params.fil) || null,
        }
    })
};

export const getAdminRAMetricsOverview = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "RA_METRICS",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAdminBDMMetricsOverview = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
        params: {
            coll: "JobPosting",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "BDM_METRICS",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAdminRecruiterMetricsOverview = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.SUBMISSOINS.GET_ALL,
        params: {
            coll: "Submission",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "RECRUITER_METRICS",
            fil: JSON.stringify(params.fil) || null,
        }
    });
};

export const getAdminRAMetricsGroup = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBS.GET_ALL,
        params: {
            coll: "Job",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "RA_METRICS_GROUP",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAdminBDMMetricsGroup = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.JOBPOSTINGS.GET_ALL,
        params: {
            coll: "JobPosting",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "BDM_METRICS_GROUP",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAdminRecruiterMetricsGroup = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.SUBMISSOINS.GET_ALL,
        params: {
            coll: "Submission",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "RECRUITER_METRICS_GROUP",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAdminMetrics = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.COMPANIES.GET_ALL,
        params: {
            coll: "Company",
            queryMode: "DASHBOARD",
            role: "ADMIN",
            type: "ADMIN_METRICS",
            fil: JSON.stringify(params.fil) || null
        }
    });
};

export const getAllUsers = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.USER_REFS.ATS_USER_GET_ALL,
        params: {
            pg: 1,
            lim: params?.lim || 100,
            ret: params?.ret || "uiid firstName lastName role",
            fil: JSON.stringify({
                "role.type": { type: "IN", value: [2, 3, 4] }
            }),
        },
    });
}


export const getAllRecruiters = async (params) => {
    return await axiosRequest({
        method: 'GET',
        url: ENDPOINTS.USER_REFS.ATS_USER_GET_ALL,
        params: {
            pg: 1,
            lim: params?.lim || 100,
            ret: params?.ret || "uiid firstName lastName role",
            fil: JSON.stringify({
                "role.type": { type: "IN", value: [4] },
            })

        },
    });
}

export const fetchTreeHierarchyApi = async (params) => {
    return await axiosRequest({
        method: "GET",
        url: `${ENDPOINTS.JOBPOSTINGS.GET_ALL}`,
        params: {
            coll: params.coll,
            fil: JSON.stringify(params.fil),
            useAggregate: params.useAggregate,
            errorHandler: true,
            pg: params?.pg,
            lim: params?.lim
        },
    });
};
